
import Shimmer from "../ui/shimmer";

export const ProfileLoading = () => (
  <div className="space-y-6 animate-fade-in transition-colors duration-300">
    <div className="space-y-4">
      <Shimmer className="h-12 w-32 rounded-full" />
      <div className="space-y-2">
        <Shimmer className="h-4 w-48" />
        <Shimmer className="h-4 w-36" />
      </div>
    </div>
    <div className="space-y-4">
      <div className="space-y-2">
        <Shimmer className="h-4 w-24" />
        <Shimmer className="h-10 w-full rounded-lg" />
      </div>
      <div className="space-y-2">
        <Shimmer className="h-4 w-32" />
        <Shimmer className="h-10 w-full rounded-lg" />
      </div>
      <div className="space-y-2">
        <Shimmer className="h-4 w-28" />
        <Shimmer className="h-10 w-full rounded-lg" />
      </div>
    </div>
    <Shimmer className="h-10 w-full rounded-lg" />
  </div>
);

export const StylesLoading = () => (
  <div className="bg-card backdrop-blur-lg rounded-xl p-6 border border-border space-y-4 transition-colors duration-300">
    <div className="flex items-center justify-between">
      <div className="space-y-0.5">
        <Shimmer className="h-6 w-32" />
        <Shimmer className="h-4 w-64" />
      </div>
      <Shimmer className="h-6 w-12 rounded-full" />
    </div>
  </div>
);

export const AdminLoading = () => (
  <div className="space-y-4 transition-colors duration-300">
    <div className="bg-card backdrop-blur-lg rounded-xl p-6 border border-border">
      <div className="space-y-4">
        <div className="grid w-full grid-cols-3 p-1 bg-muted rounded-lg">
          {[1, 2, 3].map((i) => (
            <Shimmer key={i} className="h-9 rounded-md" />
          ))}
        </div>
        <div className="space-y-4">
          {[1, 2, 3].map((i) => (
            <Shimmer key={i} className="h-24 w-full rounded-lg" />
          ))}
        </div>
      </div>
    </div>
  </div>
);

export const ClassesLoading = () => (
  <div className="space-y-4 transition-colors duration-300">
    {[1, 2].map((i) => (
      <div key={i} className="bg-card backdrop-blur-lg rounded-xl p-6 border border-border">
        <div className="space-y-4">
          <Shimmer className="h-6 w-48" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {[1, 2, 3].map((j) => (
              <Shimmer key={j} className="h-48 rounded-xl" />
            ))}
          </div>
        </div>
      </div>
    ))}
  </div>
);
